<template>
  <UCard
    :ui="{
      root: `${shadowComputed}`,
    }"
  >
    <template
      v-if="$slots.header"
      #header
    >
      <slot name="header"></slot>
    </template>
    <template #default>
      <div class="flex flex-col gap-4">
        <div
          v-if="
            props.icon ||
            props.title ||
            props.description ||
            $slots.title ||
            $slots.description ||
            $slots.trailing
          "
          class="flex flex-row gap-4 items-center"
        >
          <AppLabelWithIcon
            class="flex-1"
            :icon="props.icon"
            :title="props.title"
            :description="props.description"
          >
            <template #title>
              <slot name="title"></slot>
            </template>
            <template #description>
              <slot name="description"></slot>
            </template>
          </AppLabelWithIcon>
          <slot name="trailing"></slot>
        </div>
        <slot name="default"></slot>
      </div>
    </template>
  </UCard>
</template>

<script lang="ts" setup>
interface Props {
  icon?: string;
  title?: string;
  description?: string;
  noShadow?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  title: undefined,
  description: undefined,
  noShadow: false,
});

const shadowComputed = computed(() => {
  return props.noShadow ? "border-px shadow-none" : "";
});
</script>

<style></style>
